import { FC } from "react";
import { TitleBlockWrapper } from "./styles";

export const TitleBlock: FC<{ children: string }> = ({ children }) => (
  <TitleBlockWrapper>{children}</TitleBlockWrapper>
);

